<template>
  <a href="https://www.bagelstudio.co.il/" target="_blank" class="bagel w-inline-block">
    <img src="../assets/1bagelstudio_logo_white.svg" alt />
  </a>
</template>

<script>
export default {};
</script>

<style>
</style>
